<div  class="page-wrapper">
    <app-sidebar-component></app-sidebar-component>
    <main [ngClass]="{'inactive':!globalService.sideTrue}"  class="main">
        <app-header></app-header>
       <div id="wrapper"> <router-outlet></router-outlet></div>
    </main>
</div>